module.exports = __webpack_public_path__ + "img/katarina_living_room_1.eb57be0c.jpg";